// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: atdcK1hSZxqWg32TQQ3iWK
// Component: zbsa8DcniG
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  hasVariant,
  useCurrentUser,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import Line from "../../Line"; // plasmic-import: VMNNL5ykKM/component
import RedLink from "../../RedLink"; // plasmic-import: WBul9F6qbiKH/component
import Item from "../../Item"; // plasmic-import: a318HkZ_Ru/component
import Button from "../../Button"; // plasmic-import: tjbVKKPpomS/component
import { useScreenVariants as useScreenVariantscmLbcqStcJj } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: CMLbcqStcJJ/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic_blank_website_mobile_first.module.css"; // plasmic-import: atdcK1hSZxqWg32TQQ3iWK/projectcss
import sty from "./PlasmicMembership.module.css"; // plasmic-import: zbsa8DcniG/css
import image4KEvg2Fs from "./images/image4.png"; // plasmic-import: -K_EVG2FS/picture

createPlasmicElementProxy;

export const PlasmicMembership__VariantProps = new Array(
  "noMembership",
  "delayed",
  "nextYearPaid"
);

export const PlasmicMembership__ArgProps = new Array();

const $$ = {};

function PlasmicMembership__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "noMembership",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.noMembership
      },
      {
        path: "delayed",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.delayed
      },
      {
        path: "nextYearPaid",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.nextYearPaid
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantscmLbcqStcJj()
  });
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root,
        {
          [sty.rootdelayed]: hasVariant($state, "delayed", "delayed"),
          [sty.rootnextYearPaid]: hasVariant(
            $state,
            "nextYearPaid",
            "nextYearPaid"
          ),
          [sty.rootnoMembership]: hasVariant(
            $state,
            "noMembership",
            "noMembership"
          )
        }
      )}
    >
      <div
        className={classNames(projectcss.all, sty.freeBox__fsEc8, {
          [sty.freeBoxdelayed__fsEc8DeDkr]: hasVariant(
            $state,
            "delayed",
            "delayed"
          )
        })}
      >
        <PlasmicImg__
          data-plasmic-name={"img"}
          data-plasmic-override={overrides.img}
          alt={""}
          className={classNames(sty.img, {
            [sty.imgdelayed]: hasVariant($state, "delayed", "delayed")
          })}
          displayHeight={
            hasVariant($state, "delayed", "delayed") ? "100%" : "50%"
          }
          displayMaxHeight={"none"}
          displayMaxWidth={"100%"}
          displayMinHeight={"0"}
          displayMinWidth={"0"}
          displayWidth={"130px"}
          loading={"lazy"}
          src={{
            src: image4KEvg2Fs,
            fullWidth: 378,
            fullHeight: 378,
            aspectRatio: undefined
          }}
        />

        <Stack__
          as={"div"}
          data-plasmic-name={"figmaPaste"}
          data-plasmic-override={overrides.figmaPaste}
          hasGap={true}
          className={classNames(projectcss.all, sty.figmaPaste, {
            [sty.figmaPastedelayed]: hasVariant($state, "delayed", "delayed")
          })}
        >
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text___3XW43,
              {
                [sty.textdelayed___3XW43DeDkr]: hasVariant(
                  $state,
                  "delayed",
                  "delayed"
                )
              }
            )}
          >
            {"Suomen Golfseniorit ry"}
          </div>
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__s8Pqc,
              {
                [sty.textnextYearPaid__s8PqcVw906]: hasVariant(
                  $state,
                  "nextYearPaid",
                  "nextYearPaid"
                )
              }
            )}
          >
            {hasVariant($state, "nextYearPaid", "nextYearPaid")
              ? "J\u00e4senkortti 2024"
              : "J\u00e4senkortti 2023"}
          </div>
        </Stack__>
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__gqMFj)}>
        <div
          className={classNames(projectcss.all, sty.freeBox___3DOy, {
            [sty.freeBoxdelayed___3DOyDeDkr]: hasVariant(
              $state,
              "delayed",
              "delayed"
            ),
            [sty.freeBoxnoMembership___3DOyDwXXu]: hasVariant(
              $state,
              "noMembership",
              "noMembership"
            )
          })}
        >
          <div
            className={classNames(projectcss.all, sty.freeBox__a0Oct, {
              [sty.freeBoxdelayed__a0OctdeDkr]: hasVariant(
                $state,
                "delayed",
                "delayed"
              ),
              [sty.freeBoxnoMembership__a0OcTdwXXu]: hasVariant(
                $state,
                "noMembership",
                "noMembership"
              )
            })}
          >
            <Line className={classNames("__wab_instance", sty.line__z7FH9)} />
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__m4EWr,
                {
                  [sty.textdelayed__m4EWrdeDkr]: hasVariant(
                    $state,
                    "delayed",
                    "delayed"
                  ),
                  [sty.textnoMembership__m4EWRdwXXu]: hasVariant(
                    $state,
                    "noMembership",
                    "noMembership"
                  )
                }
              )}
            >
              {hasVariant($state, "noMembership", "noMembership")
                ? "You don't have a membership card"
                : "MEMBERSHIP CARD"}
            </div>
            <Line className={classNames("__wab_instance", sty.line__c55Na)} />
          </div>
          <div
            className={classNames(projectcss.all, sty.freeBox__eHaMy, {
              [sty.freeBoxdelayed__eHaMyDeDkr]: hasVariant(
                $state,
                "delayed",
                "delayed"
              ),
              [sty.freeBoxnoMembership__eHaMydwXXu]: hasVariant(
                $state,
                "noMembership",
                "noMembership"
              )
            })}
          >
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__gJbB4,
                {
                  [sty.textdelayed__gJbB4DeDkr]: hasVariant(
                    $state,
                    "delayed",
                    "delayed"
                  ),
                  [sty.textnoMembership__gJbB4DwXXu]: hasVariant(
                    $state,
                    "noMembership",
                    "noMembership"
                  )
                }
              )}
            >
              {hasVariant($state, "delayed", "delayed")
                ? "Your membership is over, please continue your subscription for enjoy our services."
                : ""}
            </div>
            {(
              hasVariant($state, "delayed", "delayed")
                ? true
                : hasVariant($state, "noMembership", "noMembership")
                ? true
                : false
            ) ? (
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__uypAw,
                  {
                    [sty.textdelayed__uypAwdeDkr]: hasVariant(
                      $state,
                      "delayed",
                      "delayed"
                    ),
                    [sty.textnoMembership__uypAWdwXXu]: hasVariant(
                      $state,
                      "noMembership",
                      "noMembership"
                    )
                  }
                )}
              >
                {hasVariant($state, "delayed", "delayed")
                  ? "J\u00e4senyytesi on ehtinyt p\u00e4\u00e4tty\u00e4. Saat edut taas k\u00e4ytt\u00f6\u00f6si maksamalla SGS-j\u00e4senmaksun. L\u00f6yd\u00e4t maksutiedot saamastasi laskusta. L\u00f6yd\u00e4t tarvittaessa lis\u00e4\u00e4 ohjeita osoitteesta"
                  : ""}
              </div>
            ) : null}
            <RedLink
              data-plasmic-name={"redLink"}
              data-plasmic-override={overrides.redLink}
              className={classNames("__wab_instance", sty.redLink, {
                [sty.redLinkdelayed]: hasVariant($state, "delayed", "delayed"),
                [sty.redLinknoMembership]: hasVariant(
                  $state,
                  "noMembership",
                  "noMembership"
                )
              })}
              text={
                hasVariant($state, "delayed", "delayed")
                  ? "https://www.suomengolfseniorit.fi/yhteystiedot"
                  : undefined
              }
            />

            {(
              hasVariant($state, "delayed", "delayed")
                ? true
                : hasVariant($state, "noMembership", "noMembership")
                ? true
                : false
            ) ? (
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text___8Gfl8,
                  {
                    [sty.textdelayed___8Gfl8DeDkr]: hasVariant(
                      $state,
                      "delayed",
                      "delayed"
                    ),
                    [sty.textnoMembership___8Gfl8DwXXu]: hasVariant(
                      $state,
                      "noMembership",
                      "noMembership"
                    )
                  }
                )}
              >
                <React.Fragment>
                  <React.Fragment>{""}</React.Fragment>
                  {
                    <ol
                      data-plasmic-name={"ol"}
                      data-plasmic-override={overrides.ol}
                      className={classNames(
                        projectcss.all,
                        projectcss.ol,
                        sty.ol,
                        {
                          [sty.oldelayed]: hasVariant(
                            $state,
                            "delayed",
                            "delayed"
                          )
                        }
                      )}
                    >
                      <li
                        className={classNames(
                          projectcss.all,
                          projectcss.li,
                          projectcss.__wab_text,
                          sty.li__tXshC
                        )}
                      >
                        <React.Fragment>
                          <React.Fragment>{"Please "}</React.Fragment>
                          {
                            <a
                              data-plasmic-name={"link"}
                              data-plasmic-override={overrides.link}
                              className={classNames(
                                projectcss.all,
                                projectcss.a,
                                projectcss.__wab_text,
                                projectcss.plasmic_default__inline,
                                sty.link
                              )}
                              href={
                                "https://www.suomengolfseniorit.fi/liity-jaseneksi"
                              }
                            >
                              {"fill the form on the site "}
                            </a>
                          }

                          <React.Fragment> </React.Fragment>
                        </React.Fragment>
                      </li>
                      <li
                        className={classNames(
                          projectcss.all,
                          projectcss.li,
                          projectcss.__wab_text,
                          sty.li__qscNv
                        )}
                      >
                        {"Paid membership fee"}
                      </li>
                      <li
                        className={classNames(
                          projectcss.all,
                          projectcss.li,
                          projectcss.__wab_text,
                          sty.li__uiwkv
                        )}
                      >
                        {"Return to this site and enjoy membership priviledges"}
                      </li>
                    </ol>
                  }

                  <React.Fragment>{""}</React.Fragment>
                </React.Fragment>
              </div>
            ) : null}
          </div>
          <div
            className={classNames(projectcss.all, sty.freeBox__kHd7K, {
              [sty.freeBoxdelayed__kHd7KDeDkr]: hasVariant(
                $state,
                "delayed",
                "delayed"
              ),
              [sty.freeBoxnoMembership__kHd7KdwXXu]: hasVariant(
                $state,
                "noMembership",
                "noMembership"
              )
            })}
          >
            <Item
              data-plasmic-name={"name"}
              data-plasmic-override={overrides.name}
              className={classNames("__wab_instance", sty.name, {
                [sty.namedelayed]: hasVariant($state, "delayed", "delayed"),
                [sty.namenoMembership]: hasVariant(
                  $state,
                  "noMembership",
                  "noMembership"
                )
              })}
              label={
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__lgjZ,
                    {
                      [sty.textdelayed__lgjZdeDkr]: hasVariant(
                        $state,
                        "delayed",
                        "delayed"
                      )
                    }
                  )}
                >
                  {"Nimi"}
                </div>
              }
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text___5WdJq,
                  {
                    [sty.textdelayed___5WdJqDeDkr]: hasVariant(
                      $state,
                      "delayed",
                      "delayed"
                    )
                  }
                )}
              >
                {"...."}
              </div>
            </Item>
            <Item
              data-plasmic-name={"number"}
              data-plasmic-override={overrides.number}
              className={classNames("__wab_instance", sty.number)}
              label={"SGS-j\u00e4sennumero:"}
              right={true}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text___4S2Ng
                )}
              >
                {"...."}
              </div>
            </Item>
          </div>
          <div
            className={classNames(projectcss.all, sty.freeBox__pw03Y, {
              [sty.freeBoxdelayed__pw03YDeDkr]: hasVariant(
                $state,
                "delayed",
                "delayed"
              ),
              [sty.freeBoxnoMembership__pw03YdwXXu]: hasVariant(
                $state,
                "noMembership",
                "noMembership"
              )
            })}
          >
            <Item
              data-plasmic-name={"homeCourse"}
              data-plasmic-override={overrides.homeCourse}
              className={classNames("__wab_instance", sty.homeCourse, {
                [sty.homeCoursedelayed]: hasVariant(
                  $state,
                  "delayed",
                  "delayed"
                ),
                [sty.homeCoursenoMembership]: hasVariant(
                  $state,
                  "noMembership",
                  "noMembership"
                )
              })}
              label={
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__zgPet,
                    {
                      [sty.textdelayed__zgPetDeDkr]: hasVariant(
                        $state,
                        "delayed",
                        "delayed"
                      )
                    }
                  )}
                >
                  {hasVariant(globalVariants, "screen", "desktopOnly")
                    ? "Nimetty pelioikeus kentt\u00e4"
                    : "Nimetty pelioikeus kentt\u00e4"}
                </div>
              }
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text___5Z5US,
                  {
                    [sty.textdelayed___5Z5USdeDkr]: hasVariant(
                      $state,
                      "delayed",
                      "delayed"
                    )
                  }
                )}
              >
                {"...."}
              </div>
            </Item>
            <Button
              data-plasmic-name={"homeCourseChangeBtn"}
              data-plasmic-override={overrides.homeCourseChangeBtn}
              className={classNames("__wab_instance", sty.homeCourseChangeBtn)}
              color={"white"}
              size={"compact"}
            >
              {hasVariant(globalVariants, "screen", "desktopOnly")
                ? "Vaihda"
                : "Vaihda"}
            </Button>
          </div>
          <div
            className={classNames(projectcss.all, sty.freeBox__wnZxt, {
              [sty.freeBoxnoMembership__wnZxtdwXXu]: hasVariant(
                $state,
                "noMembership",
                "noMembership"
              )
            })}
          >
            <Item
              data-plasmic-name={"item"}
              data-plasmic-override={overrides.item}
              className={classNames("__wab_instance", sty.item)}
              hideLabel={true}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__vj7Ax
                )}
              >
                {"Senior Golf Association of Finland"}
              </div>
            </Item>
            <Item
              data-plasmic-name={"number2"}
              data-plasmic-override={overrides.number2}
              className={classNames("__wab_instance", sty.number2)}
              label={
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__mvHem,
                    {
                      [sty.textdelayed__mvHemDeDkr]: hasVariant(
                        $state,
                        "delayed",
                        "delayed"
                      )
                    }
                  )}
                >
                  {"Voimassa"}
                </div>
              }
              right={true}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__kMwDj,
                  {
                    [sty.textdelayed__kMwDjDeDkr]: hasVariant(
                      $state,
                      "delayed",
                      "delayed"
                    ),
                    [sty.textnextYearPaid__kMwDjVw906]: hasVariant(
                      $state,
                      "nextYearPaid",
                      "nextYearPaid"
                    )
                  }
                )}
              >
                {hasVariant($state, "nextYearPaid", "nextYearPaid")
                  ? "04/2025"
                  : hasVariant($state, "delayed", "delayed")
                  ? "04/2024"
                  : "04/2024"}
              </div>
            </Item>
          </div>
          <Line className={classNames("__wab_instance", sty.line__mTF)} />
        </div>
      </div>
      <div
        className={classNames(projectcss.all, sty.freeBox__qR5Gh, {
          [sty.freeBoxdelayed__qR5GhDeDkr]: hasVariant(
            $state,
            "delayed",
            "delayed"
          ),
          [sty.freeBoxnoMembership__qR5GhdwXXu]: hasVariant(
            $state,
            "noMembership",
            "noMembership"
          )
        })}
      >
        <Button
          data-plasmic-name={"submit"}
          data-plasmic-override={overrides.submit}
          className={classNames("__wab_instance", sty.submit, {
            [sty.submitdelayed]: hasVariant($state, "delayed", "delayed"),
            [sty.submitnoMembership]: hasVariant(
              $state,
              "noMembership",
              "noMembership"
            )
          })}
          color={"white"}
        >
          {"Sulje"}
        </Button>
        <Button
          data-plasmic-name={"logout"}
          data-plasmic-override={overrides.logout}
          className={classNames("__wab_instance", sty.logout, {
            [sty.logoutdelayed]: hasVariant($state, "delayed", "delayed"),
            [sty.logoutnoMembership]: hasVariant(
              $state,
              "noMembership",
              "noMembership"
            )
          })}
          color={"white"}
        >
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__gqUq4,
              {
                [sty.textdelayed__gqUq4DeDkr]: hasVariant(
                  $state,
                  "delayed",
                  "delayed"
                )
              }
            )}
          >
            {hasVariant($state, "delayed", "delayed")
              ? "Kirjaudu ulos"
              : "Logout"}
          </div>
        </Button>
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text___2GlLs,
            {
              [sty.textdelayed___2GlLsDeDkr]: hasVariant(
                $state,
                "delayed",
                "delayed"
              )
            }
          )}
        >
          {"Enter some text"}
        </div>
        {(hasVariant($state, "delayed", "delayed") ? true : false) ? (
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text___77KgB,
              {
                [sty.textdelayed___77KgBdeDkr]: hasVariant(
                  $state,
                  "delayed",
                  "delayed"
                )
              }
            )}
          >
            {
              "Mik\u00e4li sinulla on kysytt\u00e4v\u00e4\u00e4 j\u00e4senasioihin liittyen, niin voit l\u00e4hett\u00e4\u00e4 s\u00e4hk\u00f6postia palvelevaan s\u00e4hk\u00f6postiin; info@golfseniorit.fi tai soittaa Maili Soukka 040 5010358.\nJ\u00e4senmaksu kaudella 2024 on 30\u20ac\nPankkiyhteytemme on FI28 5680 0020 4091 53 ja tarvittaessa pankin tunnistetieto (BIC-koodi) OKOYFIHH\nTavoitteenamme on vastata kaikkiin saamiimme viesteihin vuorokauden sis\u00e4ll\u00e4."
            }
          </div>
        ) : null}
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "img",
    "figmaPaste",
    "redLink",
    "ol",
    "link",
    "name",
    "number",
    "homeCourse",
    "homeCourseChangeBtn",
    "item",
    "number2",
    "submit",
    "logout"
  ],

  img: ["img"],
  figmaPaste: ["figmaPaste"],
  redLink: ["redLink"],
  ol: ["ol", "link"],
  link: ["link"],
  name: ["name"],
  number: ["number"],
  homeCourse: ["homeCourse"],
  homeCourseChangeBtn: ["homeCourseChangeBtn"],
  item: ["item"],
  number2: ["number2"],
  submit: ["submit"],
  logout: ["logout"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicMembership__ArgProps,
          internalVariantPropNames: PlasmicMembership__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicMembership__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicMembership";
  } else {
    func.displayName = `PlasmicMembership.${nodeName}`;
  }
  return func;
}

export const PlasmicMembership = Object.assign(
  // Top-level PlasmicMembership renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    img: makeNodeComponent("img"),
    figmaPaste: makeNodeComponent("figmaPaste"),
    redLink: makeNodeComponent("redLink"),
    ol: makeNodeComponent("ol"),
    link: makeNodeComponent("link"),
    _name: makeNodeComponent("name"),
    number: makeNodeComponent("number"),
    homeCourse: makeNodeComponent("homeCourse"),
    homeCourseChangeBtn: makeNodeComponent("homeCourseChangeBtn"),
    item: makeNodeComponent("item"),
    number2: makeNodeComponent("number2"),
    submit: makeNodeComponent("submit"),
    logout: makeNodeComponent("logout"),
    // Metadata about props expected for PlasmicMembership
    internalVariantProps: PlasmicMembership__VariantProps,
    internalArgProps: PlasmicMembership__ArgProps
  }
);

export default PlasmicMembership;
/* prettier-ignore-end */
